import * as React from "react";
import AsyncSelect from "react-select/async";
import { SearchResult, textSearch } from "../../../services/textSearch";

import { navigate } from "gatsby";
import { useEffect, useRef, useState } from "react";
import { useElementSize } from "../../../hooks/useElementSize";
import { useMonth } from "../../../hooks/useMonth";
import { getLocationPathFromSearchResult } from "../../../services/getLocationPath";
import { selectTheme, styles } from "../../../services/selectTheme";
import { set } from "lodash";
import { LoadingContext } from "../../../context/page-context";

export const SearchSelect = ({ isMobile }: { isMobile?: boolean }) => {
    const { month } = useMonth({});
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectValue, setSelectValue] = useState(null);
    const { isLoading, setIsLoading } = React.useContext(
        LoadingContext
    )
        // This context is not defined in the provided code, assuming it's defined elsewhere
    const navigationInProgress = useRef<boolean>();
    const windowHeight = useElementSize({ defaultValue: 600, useHeight: true });
    const selectRef = useRef(null);
    //const dispatch = useAppDispatch();

    const onOptionSelected = (data: SearchResult) => {
        if (!data) return;
        //dispatch(setLoading(true));
        const url = getLocationPathFromSearchResult(data, month);
        // check if the url is the same as the current path
        if (url === window.location.pathname) { 
            setMenuOpen(false);
            // unfocus the select input
            if (selectRef?.current) {
                selectRef.current.blur();
            }
            return;
        }


        setSelectValue(data);
        setMenuOpen(false);
        setIsLoading(true);
        navigationInProgress.current = true;
        setTimeout(() => {
            navigate(url);
            navigationInProgress.current = false;
            setIsLoading(false);
        },1);

        
    };

    const formatOptionLabel = (data: SearchResult) => (
        <div className={`flex cursor-pointer items-center`}>
            {data.img && (
                <img
                    src={`/thumbs-renamed/${data.img}`}
                    className={`h-[40px] w-[40px] rounded`}
                />
            )}
            {!data.img && (
                <div
                    className={`text-bold flex h-[40px] w-[40px] items-center justify-center rounded bg-sh-red-dark text-2xl text-white`}
                >
                    {data.name[0]}
                </div>
            )}
            <div className="ml-4 flex flex-1 flex-col justify-center">
                <span>{data.name}</span>
                <span className="opacity-50">{data.cName}</span>
            </div>
        </div>
    );

    const loadOptions = async (input: string) => {
        const data = await textSearch(input);
        return data.map((r) => {
            return {
                ...r,
                img: r.img?.replace(".jpg", ".png"),
                label: r.name,
                value: `${r.name}${r.cName ? `-${r.cName}` : ""}`
            };
        });
    };

    useEffect(() => {
        if (isMobile && selectRef?.current && !navigationInProgress.current) {
            setTimeout(() => {
                if (selectRef?.current) {
                    selectRef.current.focus();
                }
            }, 100);
        }
    },[selectRef, isMobile]);
    // TODO locale
    return (
        <AsyncSelect
        className="top-[0px] right-[20px]"
            autoFocus={isMobile}
            ref={selectRef}
            menuIsOpen={menuOpen}
            onFocus={() => {
                if (!navigationInProgress.current) {
                    setMenuOpen(true);
                }
            }}
            onBlur={() => setMenuOpen(false)}
            closeMenuOnSelect={true}
            
            maxMenuHeight={windowHeight - (isMobile ? 216 : 100)}
            styles={{
                ...styles,
                container: (provided, props) => {
                    return {
                        ...styles.container(provided, props),
                        width: isMobile ? undefined : 280
                    };
                }
            }}
            value={selectValue}
            loadOptions={loadOptions}
            theme={selectTheme}
            defaultOptions={true}
            formatOptionLabel={formatOptionLabel}
            controlShouldRenderValue={true}
            getOptionLabel={(o: any) => o.label}
            getOptionValue={(o: any) => o.value}
            isSearchable={true}
            onChange={(option: SearchResult & {value: string, label: string}, a: any) => {
                
                onOptionSelected(option);
            }}
            components={{
                // DropdownIndicator: () => null,
                // IndicatorSeparator: () => null,
            }}
            placeholder="Find destination..."
        />
    );
};
